import { render, staticRenderFns } from "./InfoUpdate.vue?vue&type=template&id=81c82716&scoped=true"
import script from "./InfoUpdate.vue?vue&type=script&lang=js"
export * from "./InfoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c82716",
  null
  
)

export default component.exports